module.exports = __webpack_public_path__ + "img/v_clubs.cd2d23db.png";